import { useEffect, useState } from 'react';

const useIsSafari = () => {
	const [isSafariDesktop, setIsSafariDesktop] = useState(false);
	const [isSafari, setIsSafari] = useState(false);
	const [isSafariTouch, setIsSafariTouch] = useState(false);

	useEffect(() => {
		const ua = navigator.userAgent;
		const platform = navigator.platform;

		const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
		const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

		const isiPad =
			/iPad/.test(ua) ||
			(platform === 'MacIntel' && navigator.maxTouchPoints > 1);
		const isiPhone = /iPhone/.test(ua);

		const isDesktop = !isiPad && !isiPhone;

		setIsSafari(isSafari);
		setIsSafariTouch((isSafari && isTouch) || isiPad || isiPhone);
		setIsSafariDesktop(isSafari && isDesktop);
	}, []);

	return { isSafariDesktop, isSafari, isSafariTouch };
};

export { useIsSafari };
